import { useState, useEffect } from 'react';
import StudentsListItem from "./Students-list-item";
import API from '../../API';

import AddUser from '../AddUser'
import Modal from '../Modal'
import { componentOpenAdd } from '../utils'
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import FileImport from "./FileImport";

const StudentsList = () => {
	const language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdTwo: by.RoleIdTwo;

	const [dop, setDop] = useState([]);
	const _api = new API()
	const [students, setStudents] = useState([])
	const [fieldSort, setFieldSort] = useState([])
	const getStudent = () => {
		_api.getUsers(localStorage.getItem('id'))
			.then(result => {
				// Прикпляем вариант
				const halfLength = result.users.length /2
				const isEvenHalf = result.users.length % 2 === 0;
				if(isEvenHalf){
					result.users.forEach((item,i)=>{
						if(i<halfLength){
							if(i%2===0){
								item.variants='Вариант 1_1 \n  Вариант 1_2'
							}
							else item.variants='Вариант 2_1 \n  Вариант 2_2'
						}
						else{
							if(i%2===0){
								item.variants='Вариант 3_3 \n  Вариант 3_4'
							}
							else item.variants='Вариант 4_3 \n  Вариант 4_4'
						}
					})
				}
				else{
					result.users.forEach((item,i)=>{
						item.variants = 'Не верное количество обучающихся'
				})}
				fieldSort.length > 0 ? sortByField(fieldSort, result.users) :
					setStudents(result.users)
			})
	}
	useEffect(() => {
		getStudent()
	}, [])

	function deleteItem(id) {
		_api.deleteUser(id)
			.then(data =>
				setStudents(prev => {
					return prev.filter(item => item.id !== id)
				})
			)
	}

	useEffect(() => {
		_api.getSubInformationFields().then(result => {
			if (!result) {
				return
			}
			setDop(result);
		})
	}, [])
	const dopInfo = dop.map(key =>
		<th key={key}> {key} </th>
	)

	const elements = students.map((item, i) => {
		const {id, ...itemProps} = item;
		return (
			<StudentsListItem
				key={id}
				idSt={id}
				{...itemProps}
				onDelete={deleteItem}
				dop={dop}
				count={i + 1} // порядковый номер в списке
			/>
		)
	})
	//cортировка
	const sortByField = (fields, studentsArr) => {
		if (fields.length > 0) {
			setStudents([...studentsArr].sort((a, b) => a[fields[0]] >= b[fields[0]] ? 1 : -1))
		}
		if (fields.length > 1) {
			let arr = [...studentsArr]
			arr.sort((a, b) => a['name'] >= b['name'] ? 1 : -1)
			arr.sort((a, b) => a['grade'] >= b['grade'] ? 1 : -1)
			setStudents(arr)
		}
	}

	const handlerSort = (field) => {
		let arr = [...fieldSort]
		if (!arr.includes(field)) {
			arr.push(field)
			setFieldSort(arr);
			sortByField(arr, students)
		} else {
			let newArray = arr.filter(item => {
				if (item !== field) return item
			});
			setFieldSort(newArray);
			sortByField(newArray, students)
		}
	}
	/*asdasdasdasdasdsadsd */
	return (
		<>
			<div className='teach_settings-block'>
				<h2>{language.students} ({students.length}): </h2>
				{/* <div className='teacher_settings'>
					<Modal additional={() => getStudent()} componentOpen={componentOpenAdd} component={AddUser}/>
					<FileImport getStudent={getStudent}/>
				</div> */}
			</div>
			
			<div className='overflow-block'>
				<table className="teach_table">
					<thead>
					<tr style={{border: 'none'}}>
						<th>№</th>
						<th>Вариант №</th>
						<th onClick={e => handlerSort('grade')}
							style={fieldSort.includes('grade') ? {'boxShadow': 'inset 0 0 5px rgba(0, 0, 0, .5)'} : {}}>{language.class}
						</th>
						<th onClick={e => handlerSort('name')}
							style={fieldSort.includes('name') ? {'boxShadow': 'inset 0 0 5px rgba(0, 0, 0, .5)'} : {}}>{language.FIO}
						</th>
						{dopInfo}
						<th>{language.settings}</th>
					</tr>
					</thead>
					<tbody>
					{elements}
					</tbody>
				</table>
			</div>
		</>
	)
}

export default StudentsList;